module.exports = __webpack_public_path__ + "img/logo.990a8cd1.png";